module.exports = __webpack_public_path__ + "img/error.5ec5bcaa.png";